import {
  ERROR_MESSAGES,
  FormInput,
  FormSelect,
  MASKS,
  PATTERNS,
} from "@farzoom/common-ui-components";
import { Col, Row, Space, Typography } from "antd";
import { disabledDate, useStyles } from "./personInfoModal";
import { useValidatePassport } from "./useValidatePassport";
import { COUNTRIES, IDENTITY_DOCUMENTS } from "./utils/constants";
import { ISSUE_DATE_WARNING_MESSAGE } from "./utils/validatePassport";
import { VerticalSpace } from "@app/UI/VerticalSpace";
import { FormInputDateTime } from "@app/common-ui-components/FormInputDateTime";
import { FmsUnitSearch } from "./FmsUnitSearch";

const { Text } = Typography;

export const IdentityDocumentBlock = ({ control, setValue, personW, readonly, getValues }) => {
  const classes = useStyles();
  const { issueDateWarn } = useValidatePassport(control);

  const onIssueByCodeChange = (_, opt) => {
    setValue("person.identityDocument.issuedBy", (opt?.name as string) || null);

    // HACK: чтобы значение поля изменялось по мере ввода с клавиатуры
    opt?.code && setValue("person.identityDocument.issuedByCode", opt?.code as string);
  };

  return (
    <VerticalSpace className={classes.block}>
      <FormSelect
        name="person.identityDocument.type"
        label="Тип документа"
        setValue={setValue}
        control={control}
        defaultValue={personW?.person?.identityDocument?.type}
        options={IDENTITY_DOCUMENTS}
        disabled={readonly}
      />
      <Space>
        <FormInput
          name="person.identityDocument.series"
          control={control}
          setValue={setValue}
          label="Серия"
          mask={MASKS.passportSeria}
          pattern={{
            value: PATTERNS.passportSeria,
            message: ERROR_MESSAGES.passportSeria,
          }}
        />
        <FormInput
          name="person.identityDocument.number"
          control={control}
          setValue={setValue}
          label="Номер"
          mask={MASKS.passportNumber}
          pattern={{
            value: PATTERNS.passportNumber,
            message: ERROR_MESSAGES.passportNumber,
          }}
        />
      </Space>
      <Row gutter={8} align="top">
        <Col span={15}>
          <FormInputDateTime
            name="person.identityDocument.issuedDate"
            control={control}
            setValue={setValue}
            label="Дата выдачи"
            controls={false}
            disabledDate={disabledDate}
            disabled={readonly}
            status={issueDateWarn ? "warning" : undefined}
          />
          {issueDateWarn && <Text type="warning">{ISSUE_DATE_WARNING_MESSAGE}</Text>}
        </Col>
        <Col span={9}>
          <FmsUnitSearch
            prefix="person.identityDocument.issuedByCode"
            control={control}
            setValue={setValue}
            label="Код подразделения"
            parentOnChange={onIssueByCodeChange}
            controlled
            placeholder="Введите код"
          />
        </Col>
      </Row>
      <FormInput
        name="person.identityDocument.issuedBy"
        control={control}
        setValue={setValue}
        label="Кем выдан"
        title={getValues("person.identityDocument.issuedBy")}
        disabled={readonly}
      />
      <FormSelect
        name="person.citizenship"
        label="Гражданство"
        setValue={setValue}
        control={control}
        defaultValue={personW?.person?.citizenship}
        options={COUNTRIES}
        disabled={readonly}
      />
      <FormSelect
        name="person.countryOfResidence"
        label="Страна проживания"
        setValue={setValue}
        control={control}
        defaultValue={personW?.person?.countryOfResidence}
        options={COUNTRIES}
        disabled={readonly}
      />
    </VerticalSpace>
  );
};
